import type { ReactElement } from 'react';

interface Props {
  className?: string;
}

function Icon({ className }: Props): ReactElement {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      x="0"
      y="0"
      version="1.1"
      viewBox="0 0 14 14"
      xmlSpace="preserve"
      width="24"
      height="24"
      className={className}
    >
      <path d="M11.7084 2.29171C11.0916 1.67075 10.3581 1.17801 9.54996 0.8419C8.74187 0.505792 7.87524 0.332962 7.00004 0.333375C5.23193 0.333375 3.53624 1.03575 2.286 2.286C1.03575 3.53624 0.333374 5.23193 0.333374 7.00004C0.333374 8.76815 1.03575 10.4638 2.286 11.7141C3.53624 12.9643 5.23193 13.6667 7.00004 13.6667C10.1084 13.6667 12.7 11.5417 13.4417 8.66671H11.7084C11.3651 9.6413 10.7278 10.4854 9.88449 11.0824C9.04116 11.6795 8.03333 12.0001 7.00004 12C5.67396 12 4.40219 11.4733 3.46451 10.5356C2.52682 9.59789 2.00004 8.32612 2.00004 7.00004C2.00004 5.67396 2.52682 4.40219 3.46451 3.46451C4.40219 2.52683 5.67396 2.00004 7.00004 2.00004C8.38337 2.00004 9.61671 2.57504 10.5167 3.48337L7.83337 6.16671H13.6667V0.333375L11.7084 2.29171Z" />
    </svg>
  );
}

export default Icon;
